 document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const firstLink = entry.target.querySelector('a.size-style:first-of-type');
      const logo = entry.target.querySelector('.PSW-banner-richtext-logo');
      
      if (entry.isIntersecting) {
        // Remove and re-add animation classes
        if (firstLink) {
          firstLink.classList.remove('scroll-animate');
          void firstLink.offsetWidth; // Force reflow
          firstLink.classList.add('scroll-animate');
        }
        
        if (logo) {
          logo.classList.remove('scroll-animate');
          void logo.offsetWidth; // Force reflow
          logo.classList.add('scroll-animate');
        }
      } else {
        // Reset when out of view
        if (firstLink) firstLink.classList.remove('scroll-animate');
        if (logo) logo.classList.remove('scroll-animate');
      }
    });
  }, {
    threshold: 0.2
  });

  const banner = document.querySelector('.PSW-banner-richtext');
  if (banner) {
    observer.observe(banner);
  }
}); 